import type {FC} from 'react';
import {CLIP_EMPTY} from '../../../core/entities/clip/constants';

export const NoDataText: FC = () => (
  <p className="mt-16 text-base text-black-2">{`${CLIP_EMPTY}`}</p>
);
